import React from 'react';

import {
  FlexDirectionEnum,
  FlexAlignItemsEnum,
} from 'lane-shared/types/blocks/Flex';

import ButtonStrip from '../general/ButtonStrip';

const iconSet = 'FontAwesome';

const horizontalButtons = [
  {
    value: FlexAlignItemsEnum.Start,
    icon: 'align-left',
    iconSet,
  },
  {
    value: FlexAlignItemsEnum.End,
    icon: 'align-right',
    iconSet,
  },
  {
    value: FlexAlignItemsEnum.Center,
    icon: 'align-center',
    iconSet,
  },
  {
    value: FlexAlignItemsEnum.Baseline,
    icon: 'line-height',
    iconSet,
  },
  {
    value: FlexAlignItemsEnum.Stretch,
    icon: 'align-justify',
    iconSet,
  },
] as const;

const verticalButtons = [
  {
    value: FlexAlignItemsEnum.Start,
    icon: 'align-top',
    iconSet,
  },
  {
    value: FlexAlignItemsEnum.End,
    icon: 'align-bottom',
    iconSet,
  },
  {
    value: FlexAlignItemsEnum.Center,
    icon: 'align-middle',
    iconSet,
  },
  {
    value: FlexAlignItemsEnum.Baseline,
    icon: 'line-height',
    iconSet,
  },
  {
    value: FlexAlignItemsEnum.Stretch,
    icon: 'align-justify',
    iconSet,
  },
] as const;

type Props = {
  onChange: (value: FlexAlignItemsEnum) => void;
  value: FlexAlignItemsEnum;
  flexDirection: FlexDirectionEnum;
};

export default function FlexAlignItemsInput({
  onChange,
  value,
  flexDirection = FlexDirectionEnum.Horizontal,
}: Props) {
  const buttons =
    flexDirection === FlexDirectionEnum.Horizontal
      ? horizontalButtons
      : verticalButtons;

  return (
    <ButtonStrip buttons={[...buttons]} onClick={onChange} selected={value} />
  );
}
